import { render, staticRenderFns } from "./RequestViewHeader.vue?vue&type=template&id=72706ffe"
import script from "./RequestViewHeader.vue?vue&type=script&lang=js"
export * from "./RequestViewHeader.vue?vue&type=script&lang=js"
import style0 from "./RequestViewHeader.vue?vue&type=style&index=0&id=72706ffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports